import { getAssessments } from '../../services/data-entry/assessments.service';

//Assessments list
export const UPDATE_ASSESSMENTS_LIST = 'UPDATE_ASSESSMENTS_LIST';
export const TOGGLE_ASSESSMENTS_LIST_LOADING = 'TOGGLE_ASSESSMENTS_LIST_LOADING';
export const ASSESSMENTS_LIST_ERROR = 'ASSESSMENTS_LIST_ERROR';
export const ASSESSMENTS_UPDATE_TOTAL_LIST = 'ASSESSMENTS_UPDATE_TOTAL_LIST';

export const updateAssessmentsList = (value = []) => ({
  type: UPDATE_ASSESSMENTS_LIST,
  payload: { name: 'list', value }
});

export const assessmentsListError = (value = null) => ({
  type: ASSESSMENTS_LIST_ERROR,
  payload: { name: 'error', value }
});

export const toggleLoadingAssessments = (value = false) => ({
  type: TOGGLE_ASSESSMENTS_LIST_LOADING,
  payload: { name: 'loading', value }
});

export const updateAssessmentsTotalList = (value = 0) => ({
  type: ASSESSMENTS_UPDATE_TOTAL_LIST,
  payload: { value }
});

export const loadAssessments = (skip = 0, limit = 50, filter, active = true) => {
  return async (dispatch) => {
    try {
      dispatch(toggleLoadingAssessments(true));
      dispatch(assessmentsListError());

      const newFilter = { ...filter, yearLevel: filter?.yearLevel?.filter((item) => item !== 'all') };
      const { data } = await getAssessments(skip, limit, newFilter, active);

      if (data) {
        dispatch(updateAssessmentsList(data?.paginatedResults ?? []));
        dispatch(updateAssessmentsTotalList(data?.totalRecords ?? 0));
        return;
      } else {
        dispatch(updateAssessmentsList([]));
        dispatch(updateAssessmentsTotalList(0));
      }
    } catch (error) {
      dispatch(updateAssessmentsList([]));
      dispatch(updateAssessmentsTotalList(0));
    } finally {
      dispatch(assessmentsListError());
      dispatch(toggleLoadingAssessments());
    }
  };
};

